// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfiniteTable_infiniteTable__aZ5z1 tr:last-child {
    border-bottom: none;
}

/* need to have greater specificity */
.InfiniteTable_infiniteTable__aZ5z1.InfiniteTable_infiniteTable__aZ5z1 tr:last-child > td {
    background-color: transparent;
}

.InfiniteTable_spinner__ENdFt {
    text-align: center;
    height: 60px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/InfiniteTable/InfiniteTable.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB","sourcesContent":[".infiniteTable tr:last-child {\n    border-bottom: none;\n}\n\n/* need to have greater specificity */\n.infiniteTable.infiniteTable tr:last-child > td {\n    background-color: transparent;\n}\n\n.spinner {\n    text-align: center;\n    height: 60px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infiniteTable": `InfiniteTable_infiniteTable__aZ5z1`,
	"spinner": `InfiniteTable_spinner__ENdFt`
};
export default ___CSS_LOADER_EXPORT___;
